<div class="head" padding-bottom-small-xx>
  <div class="name">{{ name() }}</div>
  @if (removable()) {
    <rt-icon-button
      (click)="remove.emit()"
      variant="transparent-dark"
      iconName="close"
      size="small"
      class="icon-danger-on-hover"
      data-cy="search-page-filter:sidebar-filter:close-button"
      margin-right-medium
    />
  }
</div>
<div class="content" margin-lr margin-bottom-medium>
  <ng-container
    [ngTemplateOutlet]="contentTemplate()"
    [ngTemplateOutletContext]="contentTemplateContext()"
  />
</div>
